module.exports = __webpack_public_path__ + "static/img/7.c34e77f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/zh/7.png
// module id = CHAw
// module chunks = 0